import { createContext, useContext } from 'react';

export const AuthContext = createContext({
    authenticated : false,
    token : null,
    cartCount : 0,
    lastUsedPromo : null
});

export function useAuth() {
    return useContext(AuthContext);
}